import React from 'react';
import './DTU.css';
import FMSimage from '../Assets/dtus2.jpeg'; // First image (full size)
import FMSimage2 from '../Assets/data1.jpg'; // Image for Key Features & Benefits
import FMSimage3 from '../Assets/data3.jpg'; // Image for How it Works section
import FMSimage4 from '../Assets/data4.jpg'; // Image for Why Choose section
import FMSimage5 from '../Assets/data5.jpg'; // Image for Industries section

const FMS = () => {
    return (
        <div className="FMS-container">
            {/* First Section: Layout for Text and Image */}
            <div className="FMS-content-container">
                {/* Left side: Text Content */}
                <div className="FMS-text">
                    <h1 className="FMS-heading">Data Transmission Unit (DTU)</h1>
                    <p className="FMS-description">
                        The Data Transmission Unit (DTU) from Vajra IoT is a versatile GSM/GPRS modem designed to read data from RS232/RS485 devices using the Modbus RTU protocol. With programmable registry mapping via SMS or USB, it ensures seamless data transmission over GPRS/GSM networks (TCP/FTP/SMTP), making it ideal for industries requiring reliable data communication, such as energy management, industrial automation, and smart infrastructure.
                    </p>
                </div>

                {/* Right side: Image */}
                <div className="FMS-image-container">
                    <img src={FMSimage} alt="Data Transmission Unit" className="FMS-image full-size" />
                </div>
            fascinati</div>

            {/* Centered Heading Between Images */}
            <div className="FMS-bottom-heading">
                <h2 className="FMS-bottom-text">Key Features & Benefits</h2>
            </div>

            {/* Second Section: New Layout for Text and Image */}
            <div className="FMS-content-container">
                {/* Left side: Text Content */}
                <div className="FMS-text">
                    <p className="FMS-description">
                        <ul>
                            <li><strong>Modbus RTU Compatibility:</strong> Reads data from RS232/RS485 devices using the Modbus RTU protocol for versatile connectivity.</li>
                            <li><strong>GSM/GPRS Connectivity:</strong> Supports TCP/FTP/SMTP protocols for reliable data transmission over GSM/GPRS networks.</li>
                            <li><strong>Programmable Registry Mapping:</strong> Allows configuration of device registry addresses via SMS or USB for flexible integration.</li>
                            <li><strong>Real-Time Data Transfer:</strong> Enables fast and secure data transmission for real-time monitoring and control.</li>
                            <li><strong>Data Security:</strong> Provides encrypted communication to ensure the safety of critical data.</li>
                        </ul>
                    </p>
                </div>

                {/* Right side: New Image for Key Features */}
                <div className="FMS-image-container">
                    <img src={FMSimage2} alt="Key Features" className="FMS-image smaller-size" />
                </div>
            </div>

            {/* Centered Heading for How it Works */}
            <div className="FMS-bottom-heading">
                <h2 className="FMS-bottom-text">How it Works</h2>
            </div>

            {/* Third Section: Layout for How it Works */}
            <div className="FMS-content-container">
                {/* Left side: Image */}
                <div className="FMS-image-container">
                    <img src={FMSimage3} alt="How It Works" className="FMS-image smaller-size" />
                </div>

                {/* Right side: Text Content */}
                <div className="FMS-text">
                    <p className="FMS-description">
                        <ul>
                            <li><strong>Data Acquisition:</strong> The DTU reads data from RS232/RS485 devices using the Modbus RTU protocol.</li>
                            <li><strong>Configuration:</strong> Registry mapping is programmed via SMS or USB, ensuring compatibility with various devices.</li>
                            <li><strong>Data Transmission:</strong> Data is transmitted securely over GSM/GPRS networks using TCP, FTP, or SMTP protocols.</li>
                            <li><strong>Real-Time Monitoring:</strong> Provides real-time data to a centralized platform for analysis and visualization.</li>
                            <li><strong>Alerting System:</strong> Sends notifications for anomalies or critical events, enabling rapid response.</li>
                        </ul>
                    </p>
                </div>
            </div>

            {/* New Section: Why Choose Us */}
            <div className="FMS-bottom-heading">
                <h2 className="FMS-bottom-text">Why Choose Our Data Transmission Unit</h2>
            </div>

            <div className="FMS-content-container">
                {/* Left side: Text Content */}
                <div className="FMS-text">
                    <p className="FMS-description">
                        <ul>
                            <li><strong>Versatile Connectivity:</strong> Supports RS232/RS485 devices and multiple communication protocols for broad compatibility.</li>
                            <li><strong>Easy Configuration:</strong> Programmable via SMS or USB, simplifying setup and integration.</li>
                            <li><strong>Reliable Performance:</strong> Ensures stable data transmission in demanding environments for consistent operation.</li>
                            <li><strong>Cost Efficiency:</strong> Reduces operational costs through automation and remote data management.</li>
                        </ul>
                    </p>
                </div>

                {/* Right side: Image */}
                <div className="FMS-image-container">
                    <img src={FMSimage4} alt="Why Choose Us" className="FMS-image smaller-size" />
                </div>
            </div>

            {/* New Section: Industries Using Our DTU */}
            <div className="FMS-bottom-heading">
                <h2 className="FMS-bottom-text">Industries Using Our System</h2>
            </div>

            <div className="FMS-content-container reverse-order-last">
                {/* Left side: Image for Industries */}
                <div className="FMS-image-container">
                    <img src={FMSimage5} alt="Industries Using DTU" className="FMS-image smaller-size" />
                </div>

                {/* Right side: Text Content */}
                <div className="FMS-text">
                    <p className="FMS-description">
                        Our Data Transmission Unit is trusted across various sectors for its robust and versatile data communication capabilities:
                        <ul>
                            <li>Energy Management</li>
                            <li>Industrial Automation</li>
                            <li>Smart Infrastructure</li>
                            <li>Telecommunications</li>
                            <li>Environmental Monitoring</li>
                        </ul>
                    </p>
                </div>
            </div>

        </div>
    );
};

export default FMS;